// Only public feed fields are persisted; credentials and arbitrary response fields are excluded.
const VERSION = 1;
const MAX_AGE_MS = 24 * 60 * 60 * 1000;
const PAGE_SIZE = 4;
const fields = ['post_uuid','item_uuid','id','recipe_uuid','user_uuid','username','avatar_url','item_type','title','body','mime_type','mime_url','image_url','thumbnail_url','feed_url','media','ingredients','steps','created_at','comments_count','upvotes','downvotes','user_vote','saved','remix_source_post_uuid','remix_source_title','remix_source_username'];
const clean = item => Object.fromEntries(fields.filter(key => Object.prototype.hasOwnProperty.call(item,key)).map(key => [key,item[key]]));
function feedCacheKey(scope) { return 'recettes.feed.v1:' + String(scope || 'guest'); }
function encodeFeedSnapshot(items,hasMore,scope,now=Date.now()) {
 if(!Array.isArray(items)||!items.length)return null;
 return JSON.stringify({version:VERSION,scope:String(scope||'guest'),savedAt:now,hasMore:!!hasMore,items:items.slice(0,PAGE_SIZE).map(clean)});
}
function decodeFeedSnapshot(raw,scope,now=Date.now()) {
 try {
  const data=JSON.parse(raw);
  if(data.version!==VERSION||data.scope!==String(scope||'guest')||!Number.isFinite(data.savedAt)||data.savedAt>now||now-data.savedAt>MAX_AGE_MS||!Array.isArray(data.items)||!data.items.length||data.items.length>PAGE_SIZE)return null;
  if(data.items.some(item=>!item||typeof item!=='object'||!(item.post_uuid||item.item_uuid||item.id)))return null;
  return {...data,items:data.items.map(clean)};
 } catch { return null; }
}
function feedPreviewUrls(items) {
 return (items||[]).slice(0,2).map(item=>item.mime_type?.startsWith('image/')?(item.feed_url||item.mime_url||item.image_url):item.thumbnail_url).filter(url=>typeof url==='string'&&/^https?:\/\//.test(url));
}
export {feedCacheKey,encodeFeedSnapshot,decodeFeedSnapshot,feedPreviewUrls,PAGE_SIZE};
